import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NoPermission from "../NoPermission";

const IdentityGuard = ({ requiredIdentity, children }) => {
  const permission = useSelector((state) => state.permission);

  if (!permission.initialized) return null;

  if (!permission.isUnionUser) {
    return <Navigate to="/view/no_access?scene=union_not_open" replace />;
  }

  if (permission.needSelectIdentity || !permission.currentIdentity) {
    return <Navigate to="/view/identity_select" replace />;
  }

  if (permission.identityType !== requiredIdentity) {
    return <NoPermission description="仅主账号可访问该页面" />;
  }

  return children;
};

export default IdentityGuard;
